export default __webpack_public_path__ + "static/media/ic_metis_40.0a6478e7.svg";